import * as React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import styles from './why-free.module.scss'

const WhyFree = () => (
  <div className={styles.root}>
    <div className={styles.outer}>
      <div className={styles.inner}>
        <FormattedHTMLMessage defaultMessage="Gratis för alltid" id="diy-accounting.why-free.heading" tagName="h2" />
        <FormattedHTMLMessage
          defaultMessage="<p>Vi på Dooer älskar företagande och vi vill mer än gärna vara med på din resa. Att starta och driva eget ska vara roligt, därför förenklar och automatiserar vi nu den tråkiga administrationen. Då kan du fokusera på ditt företag utan onödiga hinder.</p><p>Du ska inte behöva vara ekonom för att sköta din bokföring. Vår mjukvara är därför helt anpassat till dig som företagare, med funktioner som du förstår. Du får dessutom tillgång till funktioner som många andra aktörer tar betalt för - helt gratis med Dooer.</p><p>Men hur kan det vara gratis kanske du frågar dig. Vad är haken? Det är enkelt, det finns ingen hake. Vi vill se förändring i bokföringsbranschen och vi vill att du ska ha möjligheten att vara en del av det.</p><p>Vi är glada att ha med dig på resan, och att vi får vara med på din.</p>"
          id="diy-accounting.why-free.lede"
          tagName="p"
        />
      </div>
    </div>
  </div>
)

export default WhyFree
